export const TOGGLE_ENABLED = 100;
export const TOGGLE_DISABLED = 0;
